/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Util = exports.Types = exports.ThemeProvider = exports.SessionStorage = exports.Db = exports.ApiNormalizer = exports.Api = exports.PROVINCES = exports.COUNTRY_CODES = void 0;

var api_1 = __importDefault(require("./api"));

exports.Api = api_1.default;

var Db = __importStar(require("./db"));

exports.Db = Db;

var leads_1 = require("./helpers/leads");

Object.defineProperty(exports, "COUNTRY_CODES", {
  enumerable: true,
  get: function get() {
    return leads_1.COUNTRY_CODES;
  }
});
Object.defineProperty(exports, "PROVINCES", {
  enumerable: true,
  get: function get() {
    return leads_1.PROVINCES;
  }
});

var normalizer_1 = require("./normalizer");

Object.defineProperty(exports, "ApiNormalizer", {
  enumerable: true,
  get: function get() {
    return normalizer_1.ApiNormalizer;
  }
});

var sessionStorage_1 = __importDefault(require("./sessionStorage"));

exports.SessionStorage = sessionStorage_1.default;

var ThemeProvider = __importStar(require("./ThemeProvider"));

exports.ThemeProvider = ThemeProvider;

var Types = __importStar(require("./types"));

exports.Types = Types;

var Util = __importStar(require("./util"));

exports.Util = Util;